import rateHtml from './index.html'
import './index.css'

function parseDom (html) {
  let ele = document.createElement('div')
  ele.innerHTML = html
  return ele.childNodes[0]
}
/**
 * 倍速播放组件
 */
export default class RateComponent {
  /**
   * @constructor 倍速播放组件构造函数
   */
  constructor (props) {
    this.props = props
    this.html = parseDom(rateHtml)
  }

  createEl (el) {
    let eleControlbar = el.querySelector('.prism-controlbar')
    eleControlbar.appendChild(this.html)
  }

  created (player, e) { // 组件的生命周期可以去看官方文档
    player.setSpeed(this.props.rate ? this.props.rate : '1')
    let rateListEle = this.html.querySelector('.rate-list')
    let currentRateEle = this.html.querySelector('.current-rate')
    currentRateEle.innerText = this.props.rate + 'x'
    let currentEle = rateListEle.querySelector('.current')
    if (currentEle) currentEle.className = ''
    if (this.props.rate === '1.5') {
      rateListEle.children[2].className = 'current'
    } else if (this.props.rate === '1.25') {
      rateListEle.children[1].className = 'current'
    } else {
      rateListEle.children[0].className = 'current'
    }
  }

  ready (player, e) {
    let currentRateEle = this.html.querySelector('.current-rate')
    let rateListEle = this.html.querySelector('.rate-list')
    let timeId = null
    currentRateEle.onclick = () => {
      rateListEle.style.display = 'block'
    }
    currentRateEle.onmouseleave = () => {
      timeId = setTimeout(() => {
        rateListEle.style.display = 'none'
      }, 100)
    }

    rateListEle.onmouseenter = () => {
      clearTimeout(timeId)
    }
    rateListEle.onmouseleave = () => {
      rateListEle.style.display = 'none'
    }

    rateListEle.onclick = ({ target }) => {
      let rate = target.dataset.rate
      sessionStorage.playerRate = rate
      if (rate) {
        player.setSpeed(rate)
        if (target.className !== 'current') {
          let currentEle = rateListEle.querySelector('.current')
          if (currentEle) {
            currentEle.className = ''
          }
          target.className = 'current'
        }
        rateListEle.style.display = 'none'
        currentRateEle.innerText = rate + 'x'
      }
    }
  }
}
